exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ant-table-thead tr th {\n  background-color: rgba(230, 234, 243, 0.3); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/core/Table/style.scss
// module id = 1044
// module chunks = 0